export default __webpack_public_path__ + "static/media/Urban Transport.c436f381.pdf";